import css from 'styled-jsx/css';

const styles = css.global`.desktop {
    display: none;
}

#banco-do-auto-carro .container-carro {
    display: flex;
    flex-direction: column;
    position: relative;
}

#banco-do-auto-carro .carro-title {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    margin: 0;
}

#banco-do-auto-carro .carro-title b {
    color: #C00;
}

#banco-do-auto-carro .carro-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
    margin-top: 10px;
    max-width: 630px;
}

#banco-do-auto-carro .carro-paragrafo b {
    font-weight: 600;
}

#banco-do-auto-carro .banco-do-auto-imagem {
    width: 100%;
    max-width: 350px;
    margin-top: 48px;
    margin-bottom: 16px;
}

#banco-do-auto-carro .container-carro {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

#banco-do-auto-carro .container-carro {
    display: flex;
    flex-direction: column !important;
}



#banco-do-auto-carro .carro-negrito {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    margin: 16px 0 6px;
    display: block;
}

@media(min-width: 992px) {
    .mobile {
        display: none !important;
    }

    #banco-do-auto-carro .banco-do-auto-imagem {
        margin-right: 74px;
    }

    #banco-do-auto-carro .link-banco-do-auto-carro {
        color: #C00;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-decoration: underline;
    }

    #banco-do-auto-carro .carro-title {
        max-width: unset;
        font-size: 34px;
    }

    #banco-do-auto-carro {
        height: 409px;
        display: flex;
    }

    #banco-do-auto-carro .container-carro {
        flex-direction: row!important;
    }
    #banco-do-auto-carro .embla__slide {
        display: flex;
        align-items: flex-start;
    }
    #banco-do-auto-carro .home-pagination .embla__prev.enable-mobile-arrows, 
    #banco-do-auto-carro .home-pagination .embla__next.enable-mobile-arrows {
        background-size: 20px 20px;
    }
    /* #banco-do-auto-carro .embla__prev,
    #banco-do-auto-carro .embla__next {
        display: none;
    } */

    /* #banco-do-auto-carro .home-pagination {
        position: absolute;
        right: 36%;
        bottom: 15%;
    } */
}`;

export default styles;